import styled from "styled-components";

export const StyledApp = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  .result-wrapper {
    position: absolute;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 200;
  }
  .confetti {
    width: 100vw;
    height: 100vh;
  }
`;
